import React, {Component} from "react";
import PropTypes from 'prop-types';
import VideoItem from "./VideoItem";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../../actions/gallery";
import ReactImageFallback from "react-image-fallback";
import * as Utils from "../../../lib/utils";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import AuthService from "../../../lib/AuthService";
class Slider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            withInfo : true,
            showInfo : false,
            downLoad : true,
            currentItem: {},
            showGalleryDelt: false,
            showConfirmDelete: false,
            asset_id:0

        };
        this.Auth = new AuthService();
        this.resetActiveItem = this.resetActiveItem.bind(this);
        this.handleDwnld = this.handleDwnld.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deltoggle = this.deltoggle.bind(this);
        this.deletecofrimtoggle = this.deletecofrimtoggle.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.confirmAssetDelete=this.confirmAssetDelete.bind(this);

    }

     componentDidMount() {
         this.setState({currentItem: this.props.galleryData.galleryItems });
     }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    updateItemIndex(e, type) {
        if(type === 'prev') {
            if(this.props.galleryInfo.itemIndex >0) {
                --this.props.galleryInfo.itemIndex;
            } else {
                this.props.galleryInfo.itemIndex = this.props.galItems.length-1;
            }

        }
        else{

            if(this.props.galleryInfo.itemIndex < this.props.galItems.length-1) {
                ++this.props.galleryInfo.itemIndex;
            }
            else {
                this.props.galleryInfo.itemIndex = 0;
            }
        }
        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galItems[itemIndex];
        this.setState({currentItem: currentItem });

        var elems = document.querySelectorAll(".sl-item");
        [].forEach.call(elems, function(el) {
            el.classList.remove("active");
        });
        document.querySelectorAll('.sl-item')[this.props.galleryInfo.itemIndex].classList.add('active');

        let data = {"index" :  this.props.galleryInfo.itemIndex};
        this.props.setItemId(data);
        if( this.props.galleryInfo.gal_type === 'VIDEO' || this.props.vgtyp === 'VDO') {
            var videoCtr = document.getElementById("video"+itemIndex);
            var currentVideo = videoCtr.getElementsByTagName('video')[0];
            currentVideo.pause();
        }
    }


    resetActiveItem() {
        var graphicBlocks = document.getElementsByClassName('glery-main');
        let itemIndex = this.props.galleryInfo.itemIndex;
        if( this.props.galleryInfo.gal_type === 'VIDEO' || this.props.vgtyp === 'VDO' ) {
            var videoCtr = document.getElementById("video"+itemIndex);
            var currentVideo = videoCtr.getElementsByTagName('video')[0];
            currentVideo.pause();
        }
        graphicBlocks[itemIndex].classList.remove("active");
        this.props.closeModal();
    }

    handleDwnld(e,filename,name, fileId){
        Utils.forceDownload(this.props.pageSettingsData.config.BUCKET_PATH +'assets/slider/'+filename, filename);
        this.props.trackdownload({fileId : fileId});
    }
    handleDelete(e,filename,imgid, fileId){
        this.setState({
            showGalleryDelt: !this.state.showGalleryDelt,
            asset_id : imgid
        });
        let data = {"itemid" :  imgid};
        this.props.vignetsCount(data);
    }

    deltoggle() {
        this.setState({
            showGalleryDelt: !this.state.showGalleryDelt
        });
    }
    deletecofrimtoggle() {
        this.setState({
            showConfirmDelete: !this.state.showConfirmDelete,
            showGalleryDelt: false
        });
    }
    confirmDelete() {
        this.setState({
            showConfirmDelete: !this.state.showConfirmDelete
        });
        this.deltoggle();
    }
    confirmAssetDelete() {
        let data = {"itemid" :  this.state.asset_id, "module" :'Gallery',"action":'Delete',"relation_source":'Vignets', "updated_user" :this.Auth.getProfile().user_id};
        this.props.Gallerydelete(data);
        this.setState({
            showConfirmDelete: false,
            showGalleryDelt: false
        });

    }

    render() {

        let items = this.props.galItems;

        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = (this.props.galItems && this.props.galItems.length > 0) ? this.props.galItems[itemIndex] : {};


        let imgDim = (currentItem && currentItem.img_dim !== " X ") ? currentItem.img_dim :'' ;
       //let currentItem = this.state.currentItem;
        return (
            <div class="slider-modal vig-modal modal fade show" id="imagepreview" tabindex="-1" role="dialog" style={{display:'block'}} >
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <button type="button" className="close glery-popup-close" data-dismiss="modal" onClick={() => this.resetActiveItem()}></button>
                        <div className="modal-body">

                            <div class="gallery-modal-wrapper mob-galy">
                                <div id="carouselExampleIndicators" className="carousel slide gallery-modal" data-ride="carousel" >
                                    <div className="carousel-inner">
                                        {items && this.props.galleryInfo.gal_type === 'MY_UPLOADS' && this.props.vgtyp !== 'VDO' &&
                                            items.map((entry, index) => {
                                                let imgpath = entry.img_path;
                                                let defImgSrc = require("./../../../assets/images/no-image.jpg");

                                                return(
                                                    <div className={ `carousel-item item ${(this.props.galleryInfo.itemIndex === index ? "active" : "")}` }>

                                                        <ReactImageFallback
                                                            className="d-block w-100 "
                                                            src={imgpath}
                                                            fallbackImage={defImgSrc}
                                                            initialImage={defImgSrc}
                                                            alt="cool image should be here"
                                                        />
                                                    </div>
                                                )
                                            })

                                        }


                                        {items && ( this.props.galleryInfo.gal_type === 'VIDEO' || this.props.vgtyp === 'VDO') &&
                                        items.map((entry, index) =>
                                            <VideoItem item = {entry} iteration={index} />
                                        )
                                        }
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselExampleIndicators"
                                       role="button" data-slide="prev"  onClick={(e) => this.updateItemIndex(e,'prev')}>
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselExampleIndicators"
                                       role="button" data-slide="next" onClick={(e) => this.updateItemIndex(e,'next')}>
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                {/*this.state.withInfo &&
                                <div className="gallery-option">
                                    <button className="file-info-gallery" onClick = {(e) => this.showItemInfo(e)}></button>
                                </div>

                               */ }
                                {this.state.withInfo &&
                                <div className="gallery-toggler-block">
                                    <span className="popup-library icon-lib ico-play">Library</span>
                                    <ul className="popup-right-contnt">
                                        {this.props.galleryInfo.gal_type !== 'VIDEO' || this.props.vgtyp === 'VDO' &&
                                        <li>{imgDim}</li>
                                       }
                                        <li>{parseFloat(currentItem ?currentItem.img_size: 0).toFixed(2)} MB</li>
                                        <li>Type: {currentItem? currentItem.img_type: ''}</li>
                                        <li>Uploaded by: {currentItem? currentItem.uploaded_by: ''}</li>
                                        <li>Date: {currentItem ? currentItem.uploaded_on: ''}</li>
                                        {currentItem && currentItem.download_count >0 && <li>Downloads: {currentItem.download_count}</li>}
                                    </ul>
                                    <div className="galery-popup">

                                        {/*<button className="btn-galery-popup option-uplod" ></button>*/}
                                        {this.state.downLoad && this.props.source === 'vignets' && this.props.galleryInfo.gal_type === 'MY_UPLOADS' && this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex] &&
                                        <React.Fragment>
                                        <button
                                            onClick={(e) => this.handleDwnld(e, currentItem.img_name, currentItem.title, currentItem.id)}
                                            className={"btn-galery-popup option-down"}></button>
                                            {this.props.source != 'vignets' &&
                                            <button
                                                onClick={(e) => this.handleDelete(e, currentItem.img_name, currentItem.img_id, currentItem.id)}
                                                className={"btn-galery-popup icon-lib delete-ico"}></button>
                                            }
                                        </React.Fragment>
                                        }
                                        {this.state.downLoad && this.props.source === 'vignets' &&
                                        <React.Fragment>
                                            <button onClick={(e) => this.handleDwnld(e,currentItem.img_name, currentItem.title, currentItem.id)}
                                                className={"btn-galery-popup option-down"}></button>
                                            {this.props.source != 'vignets' &&
                                            <button
                                                onClick={(e) => this.handleDelete(e, currentItem.img_name, currentItem.img_id, currentItem.id)}
                                                className={"btn-galery-popup icon-lib delete-ico"}></button>
                                            }
                                        </React.Fragment>
                                         }
                                        {this.state.downLoad && this.props.source === 'gallery' && this.props.galleryInfo.gal_type === 'MY_UPLOADS' && this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex] &&
                                        <React.Fragment>
                                        <button
                                            onClick={(e) => this.handleDwnld(e, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].img_name, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].title, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].id)}
                                            className={"btn-galery-popup option-down"}></button>
                                            {this.props.source != 'vignets' &&
                                            <button
                                                onClick={(e) => this.handleDelete(e, currentItem.img_name, currentItem.img_id, currentItem.id)}
                                                className={"btn-galery-popup icon-lib delete-ico"}></button>
                                            }
                                        </React.Fragment>
                                         }

                                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' && this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex] &&
                                        <React.Fragment>
                                        <button
                                            onClick={(e) => this.handleDwnld(e, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].img_name, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].title, this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].id)}
                                            className={"btn-galery-popup option-down"}></button>
                                            {this.props.source != 'vignets' &&
                                            <button
                                                onClick={(e) => this.handleDelete(e, currentItem.img_name, currentItem.img_id, currentItem.id)}
                                                className={"btn-galery-popup icon-lib delete-ico"}></button>
                                            }
                                        </React.Fragment>

                                        }
                                        {/*<button className="btn-galery-popup option-delet"></button>*/}
                                    </div>
                                    <div className="popup-img-num">
                                        <p className="img-num-main"><span className="img-num single-img">{itemIndex+1}</span><span
                                            className="img-num img-total-num"> / { this.props.galItems.length }</span></p>
                                    </div>
                                </div>
                                }
                            </div>

                            </div>

                        </div>

                    {this.state.showGalleryDelt &&

                    <Modal isOpen={this.state.showGalleryDelt} id="delete-vignets">
                        <ModalBody>
                            {this.props.galleryInfo.vignetsCount ?
                                <div className="alert alert-default text-center" role="alert">
                                    This File is using for <label>{this.props.galleryInfo.vignetsCount}</label> vignets.
                                </div> :
                                <div className="alert alert-default text-center" role="alert">
                                    Are you sure to delete this file ?
                    </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.deltoggle}>Cancel</Button>
                            <Button color="primary" onClick={this.confirmDelete}>Confirm</Button>
                        </ModalFooter>
                    </Modal>
                    }
                    {this.state.showConfirmDelete &&

                    <Modal isOpen={this.state.showConfirmDelete} id="delete-vignets">
                        <ModalBody>
                            <div className="alert alert-default text-center" role="alert">
                                The file will be deleted permanently ?
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.deletecofrimtoggle}>No</Button>
                            <Button color="primary" onClick={this.confirmAssetDelete}>Yes</Button>
                        </ModalFooter>
                    </Modal>
                    }
                </div>
            </div>
        );
    }

}

Slider.propTypes = {
    gal_type: PropTypes.string
}

function mapStateToProps(state) {

    return {
        galleryInfo  :state.gallery.galleryUpdate,
        galleryData  :state.gallery.galleryData,
        galleryUpdate  :state.gallery.galleryUpdate,
        vignetsGallery  :state.vignets.vignetsData,
        pageSettingsData  : state.pages.pageSettings
    };

}


export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    vignetsCount : galleryActions.vignetscount,
    download : galleryActions.downloadFile,
    Gallerydelete : galleryActions.deleteFile,
    trackdownload : galleryActions.trackDownload
})(Slider));



// WEBPACK FOOTER //
// ./src/components/includes/Slider/index.js